<template>
  <span></span>
</template>

<script>
export default {
  name: 'ScrollMemory',
  mounted() {
    let resolveDataLoaded;
    this.$route.meta.dataLoaded = new Promise((resolve) => {
      resolveDataLoaded = resolve;
    });

    this.$route.meta.resolveDataLoaded = resolveDataLoaded;
    this.$route.meta.saveScrollPosition = true;
  },
  beforeDestroy() {
    // Clean up meta properties to prevent memory leaks
    delete this.$route.meta.dataLoaded;
    delete this.$route.meta.resolveDataLoaded;
    delete this.$route.meta.saveScrollPosition;
  },
};
</script>
